<template>
  <div class="mobile">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">mobile app development.</div>
          <!-- <p>My name is <span>Kennedy Baraka Konde</span>.</p> -->
          <p>
            For cross platform mobile app development, both
            <span>android</span> and <span>ios</span> i use flutter as my main
            framework.
          </p>
          <div class="technology">
            <div class="tech-title">Flutter</div>
            <div class="level l-70 react"></div>
          </div>
        </div>
        <div class="col s12 m6 my">
          <img
            src="@/assets/vectors/mobile.svg"
            class="img-responsive swing"
            style="animation-delay: 3s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.mobile {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
  text-transform: capitalize;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
.technology {
  padding: 15px;
  border-radius: 20px;
  background: rgb(253, 251, 251);
}
.tech-title {
  color: #333;
  padding: 4px;
  text-transform: capitalize;
}
.level {
  height: 5px;
  margin-bottom: 18px;
  border-radius: 50px;
}
.flutter {
  background-color: rgb(38, 202, 231);
}
.react {
  background-color: rgb(67, 38, 231);
}

.l-50 {
  width: 50%;
}
.l-70 {
  width: 70%;
}
.l-90 {
  width: 90%;
}
.l-80 {
  width: 80%;
}
.l-100 {
  width: 100%;
}
.my {
  margin-top: 70px;
}
</style>
